namespace Nobox.Nobox {
    export interface LeadListRequest extends Serenity.ListRequest {
        ListIds?: number[];
        ListIdPicker?: string;
        Category?: string;
        Tags?: string[];
    }
}
